import React from 'react';
import ReactDOM from 'react-dom';
import Container from './components/Container';

const root = document.getElementById('root');

ReactDOM.render(
    <Container />,
    root
);